import React from 'react'
import RegistrationSearchContainer from './ManualSearchContainer'

const ManualSearch = props => (
  <RegistrationSearchContainer {...props} data-test="component-tradeIn-manualSearch" />
)

export default ManualSearch
